import React from 'react';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  sectionMargins,
  greyColours,
  brandColours,
  fontSize,
} from '../styles';
import { Container, Svg, Heading, HtmlContent } from './ui';
import flowerEyeIcon from '../images/flower-eye-icon.svg';

const StyledSteps = styled.section`
  ${sectionMargins()};
`;

const StyledHeader = styled.header`
  margin-bottom: 30px;
  text-align: center;

  ${minBreakpointQuery.small`
    margin-bottom: 40px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 50px;
  `}
`;

const StyledIcon = styled(Svg)`
  margin-bottom: 8px;
  width: 75px;
  fill: ${brandColours.primary};

  ${minBreakpointQuery.large`
    margin-bottom: 12px;
  `}
`;

const StyledItems = styled.ol`
  display: grid;
  gap: 30px;

  ${minBreakpointQuery.smedium`
    grid-template-columns: repeat(3, 1fr);
  `}

  ${minBreakpointQuery.large`
    gap: 40px;
  `}

  ${minBreakpointQuery.xxlarge`
    gap: 50px;
  `}
`;

const StyledItem = styled.li`
  padding: 25px 30px 30px;
  background-color: ${greyColours.lighterGrey};
  border-radius: 10px;

  ${minBreakpointQuery.small`
    padding: 30px 35px 35px;
  `}

  ${minBreakpointQuery.large`
    padding: 35px 40px 40px;
  `}
`;

const StyledHeading = styled.h3`
  ${fontSize(21)};

  ${minBreakpointQuery.small`
   ${fontSize(23)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(25)};
  `}
`;

const StyledText = styled.p`
  margin-top: 8px;
  line-height: 1.8;

  ${minBreakpointQuery.small`
    margin-top: 10px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 12px;
  `}
`;

const StyledContent = styled(HtmlContent)`
  margin-top: 40px;
  padding: 20px 40px 0;
  border-top: 1px solid ${greyColours.lightGrey};

  ${minBreakpointQuery.small`
    margin-top: 50px;
    padding-top: 30px;
    padding-right: 70px;
    padding-left: 70px;
  `}

  ${minBreakpointQuery.medium`
    margin-top: 60px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 70px;
    padding-top: 40px;
    padding-right: 100px;
    padding-left: 100px;
  `}
`;

const Steps = ({ heading, items, content }) => (
  <StyledSteps>
    <Container>
      <StyledHeader>
        <StyledIcon image={flowerEyeIcon} />
        <Heading alt={true}>{heading}</Heading>
      </StyledHeader>
      <StyledItems>
        {items.map(({ title, text }, id) => (
          <StyledItem key={id}>
            <StyledHeading>{title}</StyledHeading>
            <StyledText>{text}</StyledText>
          </StyledItem>
        ))}
      </StyledItems>
    </Container>
    <Container narrow={true}>
      <StyledContent html={content} />
    </Container>
  </StyledSteps>
);

export default Steps;
